// 图片上传、附件上传、长文本、图片查看组件 在表单中必须以上下结构展示
export var topLayoutList = [
    'CnInputTextArea',
    'CnOSSImageUpload',
    'CnOSSUpload',
    'CnImageViewer',
];
